// extracted by mini-css-extract-plugin
export var legendIndicator = "_9y-1";
export var legendRight = "_9y-0";